import { render, staticRenderFns } from "./VarietyList.vue?vue&type=template&id=96106d7c&scoped=true&"
import script from "./VarietyList.vue?vue&type=script&lang=ts&"
export * from "./VarietyList.vue?vue&type=script&lang=ts&"
import style0 from "./VarietyList.vue?vue&type=style&index=0&id=96106d7c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96106d7c",
  null
  
)

export default component.exports